import { render, staticRenderFns } from "./bulma_buddy.vue?vue&type=template&id=bf575238&scoped=true&lang=html"
import script from "./bulma_buddy.vue?vue&type=script&lang=js"
export * from "./bulma_buddy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf575238",
  null
  
)

export default component.exports